import { useQuery } from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';

export const useChatBotDetails = (company_id: string) => {
  const { data: chatbotDetailsResponse, isLoading } = useQuery(
    ['chatbot-details'],
    () => API_HANDLERS.COMPANY.CHATBOT({ company_id }),
    {
      enabled: !!company_id,
    },
  );

  return {
    isLoading: isLoading,
    chatbot: chatbotDetailsResponse?.data,
  };
};
